export const LOWEST_GRADE = 1;
export const HIGHEST_GRADE = 12;